export const PROPS_RULES = {
  DEFAULT: [
    key => key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-',
    'role',
    'id',
    'contenteditable',
    key => key.substr(0, 7) === 'onTouch',
    key => key.substr(0, 7) === 'onClick',
  ],
  EVENTS: [
    key => key.substr(0, 2) === 'on',
  ],
};

// bems相关
export const BEMS_COMPONENT = 'cb';
export const BEMS_COMPONENT_SEPARATOR = '-';
export const BEMS_ELEMENT_SEPARATOR = '__';
export const BEMS_MODIFIER_SEPARATOR = '--';
export const BEMS_WHEN_SEPARATOR = 'is-';
